module.exports = __webpack_public_path__ + "preview-eac7acfc/open-sans-light-42c8bdcd7ec0152f29470454820a52c9.woff";